import { useStyles } from './styles';

export const Loaders = ({ fixed }: ISpinerProps) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.wrapper} ${
        fixed ? classes.fixed : classes.relative
      }`}
      data-test-id={'Spiner'}
    >
      <div className={classes.loaderSpiner} />
    </div>
  );
};

interface ISpinerProps {
  fixed?: boolean;
}
